import cn from 'classnames'
import { getImage } from '../../../utilities/iconResolver'
import { t } from '../../../utilities/translator'
import { useEffect, useState } from 'react';
import abTesting from '../../../services/abTesting';
import { isMobile } from '../../../utilities/helpers';

declare const Didomi: any;

const WizardSplashScreen = () => {
  const [showSplashScreen, setShowSplashScreen] = useState(!!(abTesting.splashScreenBeforeWhoStep && abTesting.wizardLandingStepAlternative));

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    if (abTesting.splashScreenBeforeWhoStep && abTesting.wizardLandingStepAlternative) {
      // eslint-disable-next-line no-undef
      if (typeof Didomi !== 'undefined' && typeof Didomi.getUserStatus === 'function' && isMobile()) {
        // eslint-disable-next-line no-undef
        if (!Didomi.getUserStatus().consent_string && typeof Didomi.notice !== 'undefined') {
          // eslint-disable-next-line no-undef
          Didomi.notice.hide();
        }
      }
      timeout = setTimeout(() => {
        setShowSplashScreen(false);
        setTimeout(() => {
          // eslint-disable-next-line no-undef
          if (typeof Didomi !== 'undefined' && typeof Didomi.getUserStatus === 'function' && isMobile()) {
            // show GDPR consent only after splash screen
            // eslint-disable-next-line no-undef
            if (!Didomi.getUserStatus().consent_string && typeof Didomi.notice !== 'undefined' && window.location.search.indexOf('wizardWidget=true') === -1) {
              // eslint-disable-next-line no-undef
              Didomi.notice.show();
            }
          }
        }, 300);
      }, 4000);
    }

    // eslint-disable-next-line no-undef
    if (window.location.search.indexOf('wizardWidget=true') > -1 && typeof Didomi !== 'undefined' && typeof Didomi.getUserStatus === 'function') {
      // Hide cookie consent popup if wizardWidget=true in the url (wizard for iframe)
      // eslint-disable-next-line no-undef
      if (!Didomi.getUserStatus().consent_string && typeof Didomi.notice !== 'undefined') {
        // eslint-disable-next-line no-undef
        Didomi.notice.hide();
      }
    }

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className={cn("wizard-splash text-center", { 'wizard-splash__hide': !showSplashScreen })}>
      <div className="wizard-splash__logo">
        <img src={getImage('HF-white-Logo.svg')} alt="" className="w-full" />
      </div>
      <div className="wizard-splash__main">
        <div className="wizard-splash__txt">
          {t('onboarding.splashScreenTitle')}
        </div>
        <div className="wizard-splash__loader" />
      </div>
    </div>
  )
}

export default WizardSplashScreen
